import React from 'react';
import { Icon } from '@iconify/react';

export default function PhotoTextSection({ customText, onChangeText, maxLength = 10 }) {
  return (
    <div className="photo-section-card">
      <div className="photo-section-header">
        <h3 className="photo-section-title">
          추가 텍스트 <span className="optional-label">(선택사항)</span>
        </h3>
        <div className="photo-section-icon photo-icon-blue">
          <Icon icon="solar:text-bold" width={20} height={20} />
        </div>
      </div>
      <input
        type="text"
        className="photo-text-input"
        placeholder="사진에 적용할 텍스트를 입력하세요(10자 이내)"
        value={customText}
        onChange={(e) => onChangeText(e.target.value)}
        maxLength={maxLength}
      />
    </div>
  );
}


